import { createGlobalStyle } from 'styled-components';
export const GlobalStyles = createGlobalStyle(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    '*': {
      boxSizing: 'border-box'
    },
    '*::before': {
      boxSizing: 'border-box'
    },
    '*::after': {
      boxSizing: 'border-box'
    },
    body: {
      fontFamily: theme.fontFamily.default,
      fontWeight: theme.fontWeight['body-default'],
      fontSize: theme.fontSize['type-scale-body-default'],
      color: theme.color['text-default'],
      lineHeight: theme.lineHeight['body-default']
    }
  };
});